import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
  projectsMeta: {
    current_page: 1,
    last_page: 1,
    currentQuery: ''
  },
  projects: [],
  projectReports: [],
  projectReportsMeta: {
    current_page: 1,
    last_page: 1,
    currentQuery: ''
  },
  status: [],
  transactionTypes: [],
  projectComments: {},
  projectDirectories: {},
  currentProject: {},
  report_status: [],
  step_tasks: [],
  currentProjectLogs: [],
  currentProjectLogsMeta: {
    current_page: 1,
    last_page: 1,
    currentQuery: ''
  },
  projectsCollection: [],
  performCriterias: [],
  projectReactionEnum: [],
  estates: [],
  summaries: [],
  sheetSummariesEnum: [],
  projectsTaskAlertCount: null
}

export default {
  namespaced: true,

  state: initialState,

  getters: getters,

  actions: actions,

  mutations: mutations
}
